/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * Calculates the search radius in miles from Google Maps LatLngBounds.
 * Uses the maximum distance from the center to the bounds edges.
 *
 * @param bounds - Google Maps LatLngBounds object
 * @returns Search radius in miles
 */
export function calculateSearchRadius(bounds: google.maps.LatLngBounds): number {
  const center = bounds.getCenter();
  const northeast = bounds.getNorthEast();

  // Distance from center to northeast corner in degrees
  const latDiff = Math.abs(northeast.lat() - center.lat());
  const lngDiff = Math.abs(northeast.lng() - center.lng());

  // Convert degrees to miles (~69 miles per degree)
  const latMiles = latDiff * 69;
  // Longitude degrees vary by latitude; account for it using cosine
  const latRad = (center.lat() * Math.PI) / 180;
  const lngMiles = lngDiff * 69 * Math.cos(latRad);

  // Return the larger distance from center to bounds edge
  const maxDistance = Math.max(latMiles, lngMiles);
  return Math.ceil(maxDistance);
}
